module.exports = __webpack_public_path__ + "img/83FBBCA8-B91A-4985-B122-DF450EE3DD26.65a40ffa.png";